import { extendTheme as extendMaterialTheme } from '@mui/material/styles';
import { extendTheme as extendJoyTheme } from '@mui/joy/styles';
import { deepmerge } from '@mui/utils';
import { joyThemeTokens, materialThemeTokens } from './themeTokens';

export const joyTheme = extendJoyTheme(joyThemeTokens);
export const materialTheme = extendMaterialTheme(materialThemeTokens);
export const theme = deepmerge(joyTheme, materialTheme);
